import React, { useState } from 'react';
import './App.css';
import AdminPanel from './components/AdminPanel';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import WhyNetCup from './components/WhyNetCup';
import Products from './components/Products';
import Footer from './components/Footer';
import ProductsPage from './components/ProductsPage';
import AboutPage from './components/AboutPage';
import ContactPage from './components/ContactPage';
import FAQPage from './components/FAQPage';
import BlogPage from './components/BlogPage';
import NewsPage from './components/NewsPage';
import BlogPostDetailPage from './components/BlogPostDetailPage';
import NewsDetailPage from './components/NewsDetailPage';
import ServiceDetailPage from './components/ServiceDetailPage';
import FAQPreview from './components/FAQPreview';
import BlogPreview from './components/BlogPreview';
import NewsPreview from './components/NewsPreview';
import SectionDivider from './components/SectionDivider';

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [selectedBlogId, setSelectedBlogId] = useState(null);
  const [selectedNewsId, setSelectedNewsId] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  const whatsappNumber = '905343437123';
  const phoneNumber = '905343437123';

  const handleNavigateToService = (categoryId, subCategoryId, itemId) => {
    setSelectedService({ categoryId, subCategoryId, itemId });
    setCurrentPage('service-detail');
  };

  const isAdmin = window.location.pathname === '/admin' || window.location.hash === '#admin';

  if (isAdmin) {
    return <AdminPanel />;
  }

  const PageLayout = ({ children, onNavigateToService }) => (
    <div className="App">
      <Navbar onNavigate={setCurrentPage} onNavigateToService={onNavigateToService} />
      {children}
      <Footer onNavigate={setCurrentPage} />
      <div className="floating-buttons">
        <a href={`https://wa.me/${whatsappNumber}`} target="_blank" rel="noopener noreferrer" className="floating-whatsapp" aria-label="WhatsApp ile iletişime geç">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" fill="currentColor"/>
          </svg>
          <span className="floating-btn-label">WhatsApp</span>
        </a>
        <a href={`tel:${phoneNumber}`} className="floating-phone" aria-label="Telefon ile ara">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="currentColor"/>
          </svg>
          <span className="floating-btn-label">Hemen Ara</span>
        </a>
      </div>
    </div>
  );

  if (currentPage === 'about') {
    return <PageLayout onNavigateToService={handleNavigateToService}><AboutPage /></PageLayout>;
  }
  if (currentPage === 'contact') {
    return <PageLayout onNavigateToService={handleNavigateToService}><ContactPage /></PageLayout>;
  }
  if (currentPage === 'service-detail' && selectedService) {
    return (
      <PageLayout onNavigateToService={handleNavigateToService}>
        <ServiceDetailPage
          categoryId={selectedService.categoryId}
          subCategoryId={selectedService.subCategoryId}
          itemId={selectedService.itemId}
          onBack={() => { setSelectedService(null); setCurrentPage('products'); }}
        />
      </PageLayout>
    );
  }
  if (currentPage === 'products') {
    return (
      <PageLayout onNavigateToService={handleNavigateToService}>
        <ProductsPage
          onBack={() => setCurrentPage('home')}
          onSelectService={handleNavigateToService}
        />
      </PageLayout>
    );
  }
  if (currentPage === 'faq') {
    return <PageLayout onNavigateToService={handleNavigateToService}><FAQPage /></PageLayout>;
  }
  if (currentPage === 'blog-post') {
    return (
      <PageLayout onNavigateToService={handleNavigateToService}>
        <BlogPostDetailPage
          postId={selectedBlogId}
          onBack={() => { setSelectedBlogId(null); setCurrentPage('blog'); }}
        />
      </PageLayout>
    );
  }
  if (currentPage === 'news-item') {
    return (
      <PageLayout onNavigateToService={handleNavigateToService}>
        <NewsDetailPage
          newsId={selectedNewsId}
          onBack={() => { setSelectedNewsId(null); setCurrentPage('news'); }}
        />
      </PageLayout>
    );
  }
  if (currentPage === 'blog') {
    return (
      <PageLayout onNavigateToService={handleNavigateToService}>
        <BlogPage
          onSelectPost={(id) => { setSelectedBlogId(id); setCurrentPage('blog-post'); }}
        />
      </PageLayout>
    );
  }
  if (currentPage === 'news') {
    return (
      <PageLayout onNavigateToService={handleNavigateToService}>
        <NewsPage
          onSelectNews={(id) => { setSelectedNewsId(id); setCurrentPage('news-item'); }}
        />
      </PageLayout>
    );
  }

  return (
    <div className="App">
      <Navbar onNavigate={setCurrentPage} onNavigateToService={handleNavigateToService} />
      <Hero onNavigate={setCurrentPage} />
      <WhyNetCup />
      <SectionDivider variant={1} />
      <FAQPreview onNavigate={setCurrentPage} />
      <SectionDivider variant={2} />
      <BlogPreview onNavigate={setCurrentPage} />
      <SectionDivider variant={3} />
      <NewsPreview onNavigate={setCurrentPage} />
      <SectionDivider variant={0} />
      <Products onViewAll={() => setCurrentPage('products')} onSelectService={handleNavigateToService} />
      <SectionDivider variant={4} />
      <Footer onNavigate={setCurrentPage} />
      <div className="floating-buttons">
        <a href={`https://wa.me/${whatsappNumber}`} target="_blank" rel="noopener noreferrer" className="floating-whatsapp" aria-label="WhatsApp ile iletişime geç">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" fill="currentColor"/>
          </svg>
          <span className="floating-btn-label">WhatsApp</span>
        </a>
        <a href={`tel:${phoneNumber}`} className="floating-phone" aria-label="Telefon ile ara">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="currentColor"/>
          </svg>
          <span className="floating-btn-label">Hemen Ara</span>
        </a>
      </div>
    </div>
  );
}

export default App;
